module.exports = __webpack_public_path__ + "assets/check-circle.ab0d960a4c91753e117279bc1c1dd5eb.svg";